import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Hero from '../../components/hero/hero';
import About from '../../components/about/about';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Practice from '../../components/Practice';
import ConsultingArea from '../../components/ConsultingArea/ConsultingArea';
import PricesDark from '../../components/Prices/PricesDark';
import NewsSection from '../../components/NewsSection/NewsSection';
import Footer from '../../components/footer/Footer';
//import Testimonial from '../../components/Testimonial/Testimonial';
//import CaseStudies from '../../components/CaseStudies/CaseStudies';
//import Attorney from '../../components/attorneys';
//import Newsletter from '../../components/Newsletter/Newsletter';

const HomePage = () => {
	return (
		<>
			<Navbar hclass={'wpo-header-style-1'} topbarNone={'topbar-none'} />
			<Hero />
			<About />
			<Practice />
			<PricesDark />
			<NewsSection />
			<ConsultingArea />
			<Footer />
			<Scrollbar />
		</>
	);
};
export default HomePage;
